"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.error = error;
exports.login = login;
exports.trackPageView = trackPageView;
exports.init = init;
exports.includeJs = includeJs;

var _apiKeyHelper = require("./../../helpers/api-key-helper");

var _runtimeConfigHelper = require("./../../helpers/runtime-config-helper");

/**
 * Raygun logger
 *
 * @class RayGunHelper
 */
var isInitialized = false;

function init() {
  if (!process.env.isProd) {
    return;
  }

  if (!isInitialized) {
    isInitialized = true;
    includeJs();
  }
}

function includeJs() {
  /* eslint-disable */
  !function (a, b, c, d, e, f, g) {
    ;
    a.RaygunObject = e, a[e] = a[e] || function () {
      ;
      (a[e].o = a[e].o || []).push(arguments);
    }, f = b.createElement(c), g = b.getElementsByTagName(c)[0], f.async = 1, f.src = d, g.parentNode.insertBefore(f, g);
  }(window, document, 'script', '//cdn.raygun.io/raygun4js/raygun.min.js', 'rg4js');
  /* eslint-enable */

  window.rg4js('apiKey', (0, _apiKeyHelper.getApiKey)('raygun'));
  window.rg4js('enableCrashReporting', true);
  window.rg4js('enablePulse', true);
  window.rg4js('withTags', [(0, _runtimeConfigHelper.getRuntimeConfig)()._brand, (0, _runtimeConfigHelper.getRuntimeConfig)()._env, (0, _runtimeConfigHelper.getRuntimeConfig)()._app]);
  window.rg4js('options', {
    ignoreAjaxAbort: true,
    ignore3rdPartyErrors: true
  });

  if (process.env.isProd === false) {
    // Errors reported as coming from raygun4js in the browser console.
    // Disable this when developing
    window.rg4js('disableAutoBreadcrumbsConsole', true);
  }
}
/**
 * Triggered by Analytics Service - Do not call this methodes out side the analytics service
 *
 *
 * @memberOf RayGunHelper
 */


function trackPageView(path) {
  if (isInitialized) {
    window.rg4js('trackEvent', {
      type: 'pageView',
      path: path
    });
  }
}
/**
 * Triggered by Analytics Service - Do not call this methodes out side the analytics service
 *
 *
 * @memberOf RayGunHelper
 */


function login(name, email, accountId, globalIdentity) {
  if (isInitialized) {
    window.rg4js('setUser', {
      identifier: globalIdentity,
      isAnonymous: false,
      email: email,
      fullName: name,
      uuid: globalIdentity
    });
  }
}

function error(e) {
  if (isInitialized) {
    window.rg4js('send', {
      error: e
    });
  }
}